import { http } from "../../plugins/axios";
import { UserCredentials } from "../../types/UserCredentials.type";

const state = () => ({});

const mutations = {};

const getters = {};

const userService = import.meta.env.VITE_USER_SERVICE_URL;

const actions = {
  async login(_ctx: any, credentials: UserCredentials) {
    const endpoint = `${userService}/signin`;

    const res = await http.post(endpoint, credentials);

    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
